import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface DraftPromptDialogProps {
  open: boolean;
  onUseDraft: () => void;
  onStartNew: () => void;
}

const DraftPromptDialog: React.FC<DraftPromptDialogProps> = ({
  open,
  onUseDraft,
  onStartNew,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onStartNew} fullWidth maxWidth="xs">
      <DialogTitle>{t("draft.prompt.title") || "Черновик найден"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("draft.prompt.content") ||
            "Есть незавершенный черновик. Продолжить его или начать заново?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
        <Button onClick={onStartNew} sx={{ textTransform: "none" }}>
          {t("draft.prompt.startNew") || "Начать заново"}
        </Button>
        <Button
          onClick={onUseDraft}
          variant="contained"
          sx={{ textTransform: "none" }}
        >
          {t("draft.prompt.use") || "Продолжить"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DraftPromptDialog;
